import { useContext } from "react";
import { DesignSystemContext } from "./DesignSystemProvider.js";
const layers = ["modal", "popover", "dropdown", "datepicker", "tooltip", "colorpicker", "listDragAndDrop"];
function useZIndex(layer) {
  const context = useContext(DesignSystemContext);
  if (!context && process.env.NODE_ENV !== "production") {
    throw new Error("useZIndex can not be used outside <DesignSystemProvider>");
  }
  return context.zIndexBase + layers.indexOf(layer);
}
export {
  useZIndex
};
//# sourceMappingURL=useZIndex.js.map
